<script>
    import { getContext } from "svelte";
    const { height } = getContext("LayerCake");

    export let ctx;
    $: padding = 20;
    export let onMouseEvents;
    $: radius = onMouseEvents ? 6 : 4;
</script>

<g transform={`translate(${padding + radius * 1.5}, ${$height / 2})`}>
    {#if ctx["type"] == "tribe" && onMouseEvents}
        <circle
            class="circle-institution"
            cx="0"
            cy="0"
            r={Math.sqrt(1000 / Math.PI / 2)}
        />
    {/if}

    <rect
        class="rect-institution"
        x={0 - radius / 2}
        y={0 - radius / 2}
        width={radius}
        height={radius}
    />
</g>

<style lang="scss">
    .rect-institution {
        fill: #000;
        stroke: white;
        transition: stroke-width var(--transition),
            stroke-width var(--transition);
        stroke-width: 0.75px;
        transform-box: fill-box;
        transform-origin: center;
        transform: rotate(45deg);
        fill-opacity: 0.7;
    }

    .circle-institution {
        fill: var(--warm-50);
        fill-opacity: 0.1;
        stroke: var(--warm-50);
        stroke-opacity: 0.3;
        stroke-width: 0.25px;
        transition: stroke-opacity var(--transition),
            stroke-width var(--transition);
        pointer-events: none;
    }
</style>
